import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    height: 535,
    [theme.breakpoints.up("md")]: {
      display: 'flex'
    },
  },
  inputBox: {
    fontSize: 14,
    fontFamily: "inherit",
    padding: '12px 14px',
    // background: '#FAFAFA',
    "&:before": {
      borderBottom: "1px solid rgb(0 0 0 / 0.20)",
    },
  },
  responseContentWrapper: {
    height: 165,
  },
  responseContent: {
    [theme.breakpoints.up("md")]: {
      display: 'flex',
      alignItems: 'flex-start'
    },
    "& .multi-wrap-3": {
      "-webkit-line-clamp": '6 !important'
    }
  },
  userList: {
    width: 85,
    "& ul": {
      listStyle: 'none',
      padding: '0 20px 0 0',
      margin: 0,
      textAlign: 'center',
    },
    "& .MuiAvatar-root": {
      width: 50,
      height: 50,
      margin: '0 auto'
    },
    "& li": {
      marginBottom: 25
    }
  },
  content: {
    width: 'calc(100% - 85px)',
    borderRadius: 10,
    position: 'relative',
  },
  status: {
    position: 'absolute',
    right: 0,
    top: 0,
    color: '#fff',
    fontSize: 12,
    background: '#596581',
    borderRadius: '0 10px 0 10px',
    padding: '4px 10px'
  },
  fileType: {
    cursor: 'pointer',
    background: '#EFEFEF',
    borderRadius: 4,
    padding: 12,
    width: 105,
    maxWidth: 105,
    position: 'sticky',
    left: 0,
    top: 0,
    [theme.breakpoints.up("md")]: {
      marginRight: 16,
    },
  },
  allUsers: {
    border: 'solid 2px transparent',
    borderRadius: '50%',
    width: 58,
    height: 58,
  },
  selectedUser: {
    border: 'solid 2px #F3994E',
    borderRadius: '50%',
    width: 58,
    height: 58,
  },
  commentBox: {
    "& .MuiOutlinedInput-multiline": {
      padding: 0
    }
  },
  noComment: {
    marginTop: -20
  },
  imagePosition: {
    width: 50,
    height: 35,
    objectFit: "contain",
    margin: '0 auto 5px'
  }
}));
